import React, { useRef, useState, useEffect } from 'react';
import { sanitizeHtmlContent } from 'modules/mailbox/utils/utils';
import { sanitizeHtmlColorContent } from 'utils/utils';

const DescriptionWithToggle = ({ htmlContent }) => {
  const contentRef = useRef(null);
  const [isExpanded, setIsExpanded] = useState(false);
  const [showToggle, setShowToggle] = useState(false);
  const previewHeight = 85;

  useEffect(() => {
    const el = contentRef.current;
    if (el) {
      // Wait for rendering
      if (el.scrollHeight > previewHeight) {
        setShowToggle(true);
      } else {
        setShowToggle(false);
      }
    }
  }, [htmlContent]);

  useEffect(() => {
    const el = contentRef.current;
    if (!el) return;

    if (isExpanded) {
      const fullHeight = el.scrollHeight;
      el.style.maxHeight = `${fullHeight}px`;
      el.style.opacity = 1;
    } else {
      el.style.maxHeight = `${previewHeight}px`;
      el.style.opacity = 0.8;
    }
  }, [isExpanded]);

  return (
    <div className="text-muted mt-2">
      <div
        ref={contentRef}
        style={{
          overflow: 'hidden',
          transition: 'max-height 0.4s ease, opacity 0.4s ease',
          maxHeight: `${previewHeight}px`,
          opacity: 0.8,
        }}
        dangerouslySetInnerHTML={sanitizeHtmlContent(sanitizeHtmlColorContent(htmlContent))}
      />
      {showToggle && (
        <button
          className="btn btn-link p-0 mt-1 redirection-link-no-text-transform align-items-center d-flex"
          onClick={() => setIsExpanded((prev) => !prev)}
        >
          <span>{isExpanded ? 'View less' : 'View more'}</span>
          <i className={`ms-1 F-size12 bi ${isExpanded ? 'bi-chevron-up' : 'bi-chevron-down'} icon-transition`}></i>
        </button>
      )}
    </div>
  );
};

export default DescriptionWithToggle;
